import React from 'react';
import PropTypes from 'prop-types';

export const LightMode = ({ width, height, ...props }) => (
  <svg
    data-icon='light-mode'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11 4V1h2v3h-2Zm0 19v-3h2v3h-2Zm9-10v-2h3v2h-3ZM1 13v-2h3v2H1Zm17.7-6.3-1.4-1.4 1.75-1.8 1.45 1.45-1.8 1.75ZM4.95 20.5 3.5 19.05l1.8-1.75 1.4 1.4-1.75 1.8Zm14.1 0-1.75-1.8 1.4-1.4 1.8 1.75-1.45 1.45ZM5.3 6.7 3.5 4.95 4.95 3.5 6.7 5.3 5.3 6.7ZM12 18c-1.667 0-3.083-.583-4.25-1.75C6.583 15.083 6 13.667 6 12c0-1.667.583-3.083 1.75-4.25C8.917 6.583 10.333 6 12 6c1.667 0 3.083.583 4.25 1.75C17.417 8.917 18 10.333 18 12c0 1.667-.583 3.083-1.75 4.25C15.083 17.417 13.667 18 12 18Zm0-2c1.117 0 2.063-.387 2.838-1.162C15.613 14.063 16 13.117 16 12s-.387-2.063-1.162-2.838C14.063 8.387 13.117 8 12 8s-2.063.387-2.838 1.162C8.387 9.938 8 10.883 8 12s.387 2.063 1.162 2.838C9.938 15.613 10.883 16 12 16Z'
    />
  </svg>
);

LightMode.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LightMode.defaultProps = {
  width: 24,
  height: 24,
};
